import React from 'react';
import { Router, hashHistory } from 'react-router';
import routes from '../routes/routes';
import UserRoleActions from '../actions/UserRoleActions';

export default (props) => {
  props.user_roles.forEach((role) =>{
    UserRoleActions.addUserRole(role);
  });
  // render
  return (
    <Router history={hashHistory} >
      {routes}
    </Router>
  );
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/startup/WebPcApp.jsx